import { IRowNode } from "ag-grid-enterprise";

export function systemBalanceComparator(outletsFirst?: boolean) {
    return outletsFirst
        ? compareOutletFirst
        : compareInletFirst;
}

const inletFirstOrder: { [key: string]: number; } = { Inlet: 1, Outlet: 2, Other: 3 };
const outletFirstOrder: { [key: string]: number; } = { Outlet: 1, Inlet: 2, Other: 3 };

function compareInletFirst(nodeA: IRowNode, nodeB: IRowNode) {
    return compare(nodeA, nodeB, inletFirstOrder);
}

function compareOutletFirst(nodeA: IRowNode, nodeB: IRowNode) {
    return compare(nodeA, nodeB, outletFirstOrder);
}

function compare(nodeA: IRowNode, nodeB: IRowNode, order: { [key: string]: number; }) {
    if (order[nodeA.key ?? 0] < order[nodeB.key ?? 0]) {
        return -1;
    } else if (order[nodeA.key ?? 0] > order[nodeB.key ?? 0]) {
        return 1;
    } else {
        return 0;
    }
}
